import React from "react";
import PropTypes from "prop-types";

import { BaseIcon, ICON_SERVICE } from "../index.jsx";

import styles from "./style.css";

export function KfIllustration(props) {
  return (
    <BaseIcon
      service={ICON_SERVICE.ILLUSTRATION}
      className={`${props.className} ${styles.illustration}`}
      icon={props.icon}
      onClick={props.onClick}
      padding={props.padding}
    />
  );
}

KfIllustration.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  padding: PropTypes.string,
  onClick: PropTypes.func
};

KfIllustration.defaultProps = {
  onClick: () => {}
};
